import BaseEnum from "./base_enum.js";

class RespectedEnumDesc extends BaseEnum {

  name() {
    return "respected";
  }

  rawValues() {
    return ["herr", "frau"];
  }

}

const RespectedEnum = new RespectedEnumDesc();
export default RespectedEnum;